<template>
  <section class="travel-quote-info">
    <h2>Policy Detail</h2>
    <personal-quote-info :formData="formData"></personal-quote-info>
  </section>
</template>

<script>
import PersonalQuoteInfo from '@/views/components/modules/personal/personal-quote-info'
export default {
  name: 'quote-refer-info',
  components: {PersonalQuoteInfo},
  props: {
    formData: {
      type: Object,
      default: () => ({})
    }
  },
}
</script>

<style scoped>

</style>
